import React from 'react';
import StaticPageWrapper from "../StaticPageWrapper";
import styles from './styles.module.css';
import image from './5.png';

const About = () => {
  return (
      <StaticPageWrapper img={image} title={"ABOUT US"}>
          <p className={styles.text}>
              Umrahme is part of Traveazy Group that was established in 2014 to provide travel-related solutions to customers
              in GCC. Umrahme started as line of business within the Traveazy group (under the brand name of holidayme) and
              eventually became a standalone entity with a vision to provide Umrah related products to global travel agents &
              customers. We aspire to revolutionize the way in which Umrah travel is managed globally by bringing the Umrah
              ecosystem into an online platform which is dynamic, automated & backed up by AI.
                <br/><br/>
              Umrahme launched its first
              bookable website Umrahme.com as a customized online Umrah packaged provider with an e-visa facility. This
              product was first of its kind globally and provided unique customization opportunities across multiple
              parameters like hotels, flights & transfers to the pilgrims for their Umrah journey.
              <br/><br/>
              Subsequently, Umrahme
              signed a Memorandum of Understanding with the Ministry of Hajj & Umrah in September 2019 to provide technology
              solutions to travel agents across the globe. Powered by a strong in-house technology team, Umrahme has
              maintained a competitive edge over other players by providing best in class technology to the agents based
              across the globe. Our products are intuitive and enable bookings of complex products in a few simple steps. Our
              solutions are completed automated and provide advanced analytics to its agents to ensure that we provide
              world-class service to our end customers – the pilgrims. We also have a 24x7 support team available via chat,
              phone, email, and social media to resolve any issue in the shortest possible time.
              <br/><br/>
              Our ongoing endeavor is to
              keep investing in technology to build products around multiple aspects of the Umrah travel and to ensure that
              everyone can perform the Umrah journey in a seamless way.
              <br/><br/>
              Headquartered in Dubai, we employee 70+ people from
              various nationalities at our offices in Jeddah, Dubai, Pune & Egypt. Our team, mission, and vision has always
              generated active interest in the investment community, and we are honored to be backed by multiple institutional
              investors based in GCC and Asia.
          </p>
      </StaticPageWrapper>
  );
};

export default About;
